import { MutationHookOptions, useMutation } from '@apollo/client';

import { DELETE_UNIT } from './mutations';

export const useDeleteUnit = (options?: MutationHookOptions) => useMutation(DELETE_UNIT, options);
